export default __webpack_public_path__ + "static/media/beach-access.1232f80d.svg";